var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{key:_vm.$route.params.objectid},[(_vm.objectFull)?_c('cbs-object',{attrs:{"objectid":_vm.objectid,"object-full":_vm.objectFull}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }